<template>
    <div class="container">
        <p  class="title">{{langPage['v4-vendeurinfo']['TXT_mobileuser']}}</p>
        <div class="appLogo">
            <a href="https://apps.apple.com/fr/app/efashion-paris/id1460584296">
                <img src="@/assets/img/bottom/apple-store-badge.png" alt=""/>
            </a>
        </div>
        <div class="appLogo">
            <a href="https://play.google.com/store/apps/details?id=com.efashionparis&gl=FR">
                <img src="@/assets/img/bottom/Google_Play_2015.png" alt=""/>
            </a>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "DownloadApp",
        data() {
            return {}
        },
        mounted() {
        },
        methods() {

        },
        computed: {
        langPage() {
          return this.$store.state['langPage']
        }
      },
    }
</script>

<style lang="less" scoped src="@/assets/viewCss/views/DownloadApp.less">
</style>
